/* ez-reveal.js — reveal-on-scroll. Elements with [data-ez-reveal] gain .is-revealed on entering the viewport.
   Respects prefers-reduced-motion by revealing immediately. */
(function () {
  'use strict';

  function revealAll(nodes) {
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add('is-revealed');
    }
  }

  function init() {
    var nodes = document.querySelectorAll('[data-ez-reveal]');
    if (!nodes.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll(nodes);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    // threshold 0, NOT a ratio: a ratio threshold only fires when the visible FRACTION crosses it, and a
    // section taller than ~20x the viewport can never show 5% of itself, so it stayed at opacity 0 forever.
    // That hid the whole shop-all catalog on phones (one column, ~26,000px tall, max visible ratio 0.029).
    // With 0 + the -10% bottom margin, an element reveals once its top clears the lower 10% of the viewport.
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });

    for (var i = 0; i < nodes.length; i++) {
      observer.observe(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
